<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-row>
          <b-col sm="12">
            <table class="table">
              <tbody>
                <tr>
                  <td>MailChimp</td>
                  <td class="text-right">
                    <span v-if="tokenEmpty">
                      <a href="https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=334855094319">Connect</a>
                    </span>
                    <span v-else>
                      {{organization.mailchimp_access_token}}
                      <b-button variant="danger" @click="removeMailchimp()">
                      Remove
                    </b-button>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

const items = [
  { Site: 'MailChimp', last_name: ' <a href="https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=334855094319">MailChimp</a>' }
]

export default {
  name: 'EmailMarketing',
  data () {
    return {
      items,
      organization: {}
    }
  },
  computed: {
    tokenEmpty: function () {
      return this.organization.mailchimp_access_token === null || this.organization.mailchimp_access_token === ''
    }
  },
  methods: {
    editCompany: function () {
      let that = this
      const { name, streetAddress, city, postalCode, province } = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put(`${process.env.VUE_APP_API_URL}api/companies/${this.$route.params.id}`, {
            name: name,
            street_address: streetAddress,
            city: city,
            postal_code: postalCode,
            province: province
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              that.success = true
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    },
    getOrganization: function () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/organizations`, {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          self.organization = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getParameterByName: function (name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[[\]]/g, '\\$&')
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      let results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    removeMailchimp: function () {
      axios.post(`${process.env.VUE_APP_API_URL}api/organizations/remove_mailchimp`, {},
        {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': localStorage.getItem('user-token')
          }
        })
        .then(function (response) {
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getOrganization()
    let code = this.getParameterByName('code')
    if (code !== null) {
      axios.post(`${process.env.VUE_APP_API_URL}api/organizations/mailchimp`, { code },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': localStorage.getItem('user-token')
          }
        })
        .then(function (response) {
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
